module.exports = __webpack_public_path__ + "img/img_kv_4_thumb.b4857230.jpg";